import { AppNS } from 'app';
import ProjectAddressFormatted from 'app/ui/components/project-address-formatted/ProjectAddressFormatted';

import { Box, Card, CardContent, Divider } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import BookingSpecial from '../../../common/bookings/booking-special/BookingSpecial';
import BookingActions from '../booking-actions/BookingActions';
import BookingCustomer from '../booking-customer/BookingCustomer';

export interface BookingsListProps {
  data: Array<AppNS.ProjectLead>;
}

export default function BookingsList(props: BookingsListProps) {
  const { data } = props;

  return (
    <Card>
      <CardContent>
        {data.map((item: any, index: number) => (
          <Box key={item.id}>
            {index > 0 && <Divider />}

            <Table sx={{ width: '100%', margin: '16px 0' }} className={'no-borders'} aria-label="Project lead table">
              <TableHead>
                <TableRow>
                  <TableCell>Project</TableCell>
                  <TableCell>{item.id || ''}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {item?.type === 'special' && (
                  <TableRow>
                    <TableCell scope="row">Special inspection</TableCell>
                    <TableCell>
                      <BookingSpecial />
                    </TableCell>
                  </TableRow>
                )}
                {item?.type === 'doee' && (
                  <TableRow>
                    <TableCell scope="row">DOEE inspection</TableCell>
                    <TableCell>
                      <BookingSpecial type="doee" tooltip="DOEE Inspection" />
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell scope="row">Customer</TableCell>
                  <TableCell>
                    <BookingCustomer client={item.client} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Project Owner / Agency</TableCell>
                  <TableCell>
                    {item?.booking && (
                      <>
                        <div>{item?.booking?.agency?.fullName}</div>
                        <div>{item?.booking?.agencyCompany?.name || '-'}</div>
                      </>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Where</TableCell>
                  <TableCell>{<ProjectAddressFormatted address={item} />}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Action</TableCell>
                  <TableCell>
                    <BookingActions id={item.id} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}
